import { ChangeEvent, useCallback } from "react";
import { useIntl } from "react-intl";
import { Grid } from "@mui/material";
import { DataGridPremiumProps, GridColDef, GridRowParams, GridValidRowModel } from "@mui/x-data-grid-premium";
import { useAccount } from "wagmi";

import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { type IEventHistory } from "@framework/types";
import { useFetchQuery } from "@dzambalaorg/react-hooks";
import { IPaginationResult } from "@dzambalaorg/types-collection";

import { EventDataView } from "./event-data-view";
import { TransactionSearchForm } from "./form";
import { StyledDataGridPremium } from "./styled";
import { transactionsColumnsCreator } from "./utils";

export const MyTransactions = () => {
  // TODO - [AFTER ALL REFACTORING] - add possibility to change order in useFetchQuery
  const { isLoading, take, skip, onChangePage, allRows, totalCount } =
    useFetchQuery<IPaginationResult<IEventHistory>>("/events/my");

  const { formatMessage } = useIntl();
  const { address: account } = useAccount();

  const columns: GridColDef<GridValidRowModel>[] = transactionsColumnsCreator(formatMessage, account);

  const getDetailPanelContent = useCallback<NonNullable<DataGridPremiumProps["getDetailPanelContent"]>>(
    ({ row }: GridRowParams<IEventHistory>) => <EventDataView row={row} />,
    [],
  );

  const getDetailPanelHeight = useCallback<NonNullable<DataGridPremiumProps["getDetailPanelHeight"]>>(
    () => "auto" as const,
    [],
  );

  return (
    <Grid>
      <Breadcrumbs path={["dashboard", "transactions"]} />

      <PageHeader message="pages.transactions.title" />

      <TransactionSearchForm />

      <ProgressOverlay isLoading={isLoading}>
        <StyledDataGridPremium
          pagination
          paginationMode="server"
          sortingMode="server"
          // onSortModelChange={handleChangeSortModel as any}
          rowCount={totalCount}
          paginationModel={{ page: skip / take, pageSize: take }}
          onPaginationModelChange={({ page }) => onChangePage({} as ChangeEvent<unknown>, page)}
          pageSizeOptions={[5, 10, 25]}
          loading={isLoading}
          columns={columns}
          getDetailPanelHeight={getDetailPanelHeight}
          getDetailPanelContent={getDetailPanelContent}
          rows={allRows}
          getRowHeight={() => "auto"}
          disableAggregation
          disableRowGrouping
        />
      </ProgressOverlay>
    </Grid>
  );
};
